export default "__VITE_ASSET__a5d8e571__"